module.exports = __webpack_public_path__ + "static/media/whiteboard_sketches.51229eff.jpeg";